import React from "react";
import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <main data-testid="payment-cancel-page" className="min-h-screen flex items-center justify-center px-6">
      <div className="text-center">
        <div className="font-display text-4xl">Payment cancelled</div>
        <div className="text-secondary-fg mt-2">No funds were moved.</div>
        <Link to="/" data-testid="cancel-return-home" className="btn-ghost inline-block mt-8">Return home</Link>
      </div>
    </main>
  );
}
